<template>
  <div>
    <el-container>
      <el-header>
        <div class='logo'>亿建后台管理系统</div>
        <el-dropdown class="outLogin">
		          	<span class="el-dropdown-link">
		            	欢迎您,{{nickname}}
		            	<i class="el-icon-arrow-down el-icon--right"></i>
		          	</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="editPassword('/forgotPassword')">
              修改密码
              <!-- <router-link :to="{path: '/forgotPassword'}" class="el-dropdown-menu__item">修改密码</router-link> -->
            </el-dropdown-item>
            
            <!-- <el-dropdown-item></el-dropdown-item> -->
            <li @click="loginOut" class="el-dropdown-menu__item">退出</li>
          </el-dropdown-menu>
        </el-dropdown>
      </el-header>
      <el-container>
        <el-aside width="180px">
          <el-menu :default-active="activeName" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
                   background-color="#304156" text-color="#c7c7c7" active-text-color="#409EFF" router>
            <el-submenu :index="index+''" v-for="(items,index) in menuList" :key="index">
              <template slot="title">
                <span>{{items.menuName}}</span>
              </template>
              <el-menu-item-group>
                <el-menu-item :index="item.menuAddress" v-for="(item,key) in items.submenu" :key="key">
                  <span>{{item.menuName}}</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </el-aside>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: '',
      nickname: localStorage.getItem('nickname'),
      menuList: JSON.parse(localStorage.getItem('userMenu'))
    };
  },
  mounted() {
    this.getMetaDetail();
  },
  methods: {
    // 修改密码
    editPassword(url) {
      this.$router.push(url);
    },
    getMetaDetail() {
      if (this.$route.meta && this.$route.meta.isDetail) {
        if (typeof this.$route.meta.isDetail === 'function') {
          this.activeName = this.$route.meta.isDetail(this.$route);
        } else {
          this.activeName = this.$route.meta.isDetail;
        }
      } else {
        this.activeName = this.$route.name;
      }
    },
    loginOut() {
      localStorage.removeItem('token');
      this.$store.state.token = '';
      this.$router.push({ path: '/login' });
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath)
    }
  }
};
</script>
<style>
.logo {
  font-size: 22px;
  float: left;
}

.outLogin {
  float: right;
  padding: 5px;
  border-radius: 10px;
  height: 40px;
  line-height: 30px;
  margin-top: 10px;
  border: solid 1px gainsboro;
}

.el-header {
  position: fixed;
  width: 100%;
  background: #fff;
  height: 60px;
  line-height: 60px;
  z-index: 999;
  border-bottom: solid 1px gainsboro;
}

.el-aside {
  background-color: rgb(48, 65, 86);
  color: #333;
  text-align: center;
  min-height: 600px;
  position: fixed;
  top: 60px;
  left: 0;
  height: 100%;
  padding-bottom: 60px;
  user-select: none;
}

.el-main {
  background: #fff;
  margin: 10px 10px 0 0;
  padding: 20px;
  color: #333;
  margin-left: 190px;
}

.el-submenu {
  width: 180px;
}

.el-menu-item a {
  display: block;
}

.el-menu-item.is-active {
  background-color: rgb(38, 52, 69) !important;
}

div .el-main {
  margin-top: 60px;
}

.el-submenu__title {
  text-align: left;
}

.el-submenu .el-menu-item {
  min-width: auto !important;
}

.el-menu-item-group__title {
  padding: 0 !important;
}

.topnav {
  overflow: hidden;
  overflow: hidden;
  background: #ccc;
  margin-bottom: 20px;
}

.topnav li {
  float: left;
  height: 38px;
  background: #ccc;
  padding: 0 27px;
  line-height: 38px;
  font-size: 13px;
  cursor: pointer;
}

.topnav li.active {
  background: #409eff;
  color: #fff;
}

.stagetit {
  font-size: 15px;
  text-align: center;
  font-weight: bold;
  margin-bottom: 5px;
}

.stagetit span {
  padding: 0 10px;
}
</style>





// WEBPACK FOOTER //
// src/index.vue